document.addEventListener('DOMContentLoaded', () => {
    let indent = 80

    if (document.querySelector('[data-role="scroll-to-anchor"]')) initScrollToAnchor()

    function initScrollToAnchor() {
        const anchorElements = document.querySelectorAll('[data-role="scroll-to-anchor"]')

        for (let i = 0, len = anchorElements.length; i < len; i++) _loopAddEventScrollToAnchor(anchorElements[i])

        function _loopAddEventScrollToAnchor(node) {
            node.addEventListener('click', clickOnTheScrollElement)
        }

        window.addEventListener('resize', checkIndent)
        checkIndent()
    }

    function checkIndent() {
        //indent = window.innerWidth < 1280 ? 60 : 80
        indent = 0
    }

    function closeMenu () {
        const menu = document.querySelector('[data-element="mobile-menu"]');
        const html = document.getElementsByTagName('html')[0];
        const headerBurger = document.querySelector('.js-header-burger');

        html.classList.remove('html_no-scroll');
        menu.classList.remove('mobile-menu_active');
        headerBurger.classList.remove('is-opened');
        menu.querySelectorAll('.is-active').forEach(item => item.classList.remove('is-active'));
    }

    function clickOnTheScrollElement(event) {
        event.preventDefault()
        if (this.classList.contains('mobile-menu__link')) closeMenu()
        let elementId
        if (this.dataset.link) elementId = this.dataset.link.substr(1)
        else elementId = this.hash.substr(1)
        const element = document.getElementById(elementId)
        if (element) animateScrollToAnchor(element)
        else window.location = '/#' + elementId
    }

    function animateScrollToAnchor(theElement) {
        const positionNow = window.pageYOffset
        const positionElement = theElement.getBoundingClientRect().top + pageYOffset - indent
        const duration = 500
        const step = positionElement - positionNow
        const start = performance.now()

        requestAnimationFrame(function animate(time) {
            const timePassed = time - start

            if (timePassed > duration) {
                window.scrollTo(0, positionElement)
            } else {
                window.scrollTo(0, positionNow + step * (timePassed / duration))
                requestAnimationFrame(animate)
            }
        })
    }
});
